<template>
  <div class="update-transfer-stock">
    <KTCodePreview v-bind:title="'Thông tin phiếu chuyển kho'">
      <template v-slot:toolbar>
        <div class="row">
          <div v-if="checkPermission('STOCK_UPDATE') && !approveBy">
            <b-row class="mb-4 ml-4">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitch2"
                  v-model="isEdit"
                />
                <label
                  class="custom-control-label text-lable"
                  for="customSwitch2"
                  style="font-size: 14px; font-weight: 500"
                  >Chỉnh sửa</label
                >
              </div>
            </b-row>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <b-row class="pl-0">
          <b-form-group class="col-3">
            <label>Mã phiếu:</label>
            <p>{{ codeStockBill }}</p>
          </b-form-group>
          <b-form-group class="col-3">
            <label>Ngày tạo:</label>
            <p>{{ dateCreate }}</p>
          </b-form-group>
          <b-form-group label-class="font-weight-bolder" class="col-3">
            <label>Người tạo: </label>
            <p>{{ createBy }}</p>
          </b-form-group>
          <b-form-group label-class="font-weight-bolder" class="col-3">
            <label>Phiếu yêu cầu XNK:</label>
            <div
              v-for="stock in requireStockCode"
              :key="stock.id"
              class="productCode"
              @click="linkToRequireStock(stock)"
              style="cursor: pointer"
            >
              <span v-text="stock.code"></span>
            </div>
          </b-form-group>
        </b-row>

        <b-row class="pl-0">
          <b-col md="8">
            <b-row>
              <b-form-group class="col-6 required-control" :disabled="!isEdit">
                <label for="input-name">Chi phí vận chuyển</label>
                <b-form-input
                  class="input-style"
                  size="sm"
                  type="text"
                  v-model="shippingCost"
                  v-mask="mask"
                  placeholder="Nhập chi phí vận chuyển"
                ></b-form-input
              ></b-form-group>

              <b-form-group class="col-6 required-control" :disabled="!isEdit">
                <label for="input-name">Đơn vị vận chuyển</label>
                <b-form-input
                  class="input-style"
                  size="sm"
                  type="text"
                  v-model="shippingCompany"
                  placeholder="Nhập tên đơn vị vận chuyển"
                ></b-form-input>
              </b-form-group>
            </b-row>
            <b-row>
              <b-form-group class="col-6" :disabled="!isEdit">
                <label for="input-name">Mã đơn vị vận chuyển</label>
                <b-form-input
                  class="input-style"
                  size="sm"
                  type="text"
                  v-model="shippingCode"
                  placeholder="nhập mã đơn vị vận chuyển"
                ></b-form-input>
              </b-form-group>

              <b-form-group class="col-6" :disabled="!isEdit">
                <label for="input-name">Số hóa đơn vận chuyển</label>
                <b-form-input
                  class="input-style"
                  size="sm"
                  type="text"
                  v-model="shippingInvoiceNumber"
                  placeholder="Nhập số hóa đơn vận chuyển"
                ></b-form-input
              ></b-form-group>
            </b-row>
            <b-row>
              <b-form-group class="col-6 required-control" :disabled="!isEdit">
                <label>Kho nguồn:</label>
                <b-form-select
                  :disabled="true"
                  class="mt-2 select-style"
                  v-model="$v.form.sourceStoreSelected.$model"
                  :options="listInventories"
                  size="sm"
                  value-field="id"
                  text-field="name"
                >
                </b-form-select>
              </b-form-group>

              <b-form-group class="col-6 required-control" :disabled="!isEdit">
                <label>Kho đích:</label>
                <b-form-select
                  :disabled="status > 1 ? true : false"
                  class="mt-2 select-style"
                  v-model="$v.form.desStoreSelected.$model"
                  :options="listInventories"
                  size="sm"
                  value-field="id"
                  text-field="name"
                  disabled-field="notEnabled"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled
                      >Chọn kho đích</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </b-form-group>
            </b-row>
            <b-row>
              <b-form-group :disabled="!isEdit" class="col-12">
                <template>
                  <span>Nội dung:</span>
                </template>
                <b-form-textarea
                  size="sm"
                  v-model="description"
                  :placeholder="'Thêm nội dung...'"
                  :rows="3"
                  :max-rows="3"
                ></b-form-textarea>
              </b-form-group>
            </b-row>
          </b-col>
          <!-- <b-col md="6">
            <TransferIntermediate
              :items="transferIntermediateItems"
              :editable="false"
            />
          </b-col> -->
        </b-row>
        <b-row class="mb-4 pl-0">
          <b-col md="2" class="pr-0">
            <b-form-select
              class="select-style"
              v-model="selectTypeSearch"
              :options="listTypeSearch"
              size="sm"
              value-field="id"
              text-field="name"
              :disabled="!isEdit"
              @change="onChangeTypeSearch()"
            ></b-form-select>
          </b-col>
          <b-col md="6" class="pl-0">
            <vue-autosuggest
              v-model="searchProduct"
              :suggestions="filteredOptionsProduct"
              @selected="onSelectedProduct"
              :limit="10"
              @input="onInputChangProduct"
              :input-props="inputSearchProductProp"
              :should-render-suggestions="
                (size, loading) => size >= 0 && !loading && searchProduct !== ''
              "
            >
              <div
                v-if="selectTypeSearch === 1"
                slot-scope="{ suggestion }"
                style="display: flex; align-items: center"
              >
                <div :style="{ display: 'flex', color: 'navyblue' }">
                  {{ suggestion.item.name }}
                </div>
              </div>
              <div
                v-else-if="selectTypeSearch === 3"
                slot-scope="{ suggestion }"
                style="display: flex; align-items: center"
              >
                <div :style="{ display: 'flex', color: 'navyblue' }">
                  {{ suggestion.item.name }} (SK:
                  {{ suggestion.item?.productChassis?.chassisNumber || '' }},
                  SM: {{ suggestion.item?.productChassis?.engineNumber || '' }})
                </div>
              </div>
              <div
                v-else-if="selectTypeSearch === 4"
                slot-scope="{ suggestion }"
                style="display: flex; align-items: center"
              >
                <div :style="{ display: 'flex', color: 'navyblue' }">
                  {{ suggestion.item.name }} ( Seri:
                  {{ suggestion.item?.productSeries?.serialNumber || '' }} )
                </div>
              </div>
            </vue-autosuggest>
          </b-col>
        </b-row>
        <ProductStockInfoModal
          ref="product-stock-info"
          :productItem="selectedProductStock"
          :validEngineFromChassis="true"
          mode="export"
          :sourceStoreId="form.sourceStoreSelected"
          v-on:updateProductStockInfo="handleUpdateProductStockInfo"
        />
        <span class="font-weight-bolder">Danh sách sản phẩm:</span>
        <table
          class="table table-bordered table-vertical-center table-hover col-12 mt-4"
        >
          <thead>
            <tr>
              <th scope="col" class="title-center" style="width: 20%">
                Tên sản phẩm
              </th>
              <th scope="col" class="title-center" style="width: 5%">Tồn</th>
              <th scope="col" class="title-center" style="width: 19%">
                Số khung - Số máy / Số serial
              </th>
              <th scope="col" class="title-center" style="width: 14%">
                Số lượng
              </th>
              <th
                scope="col"
                class="title-center"
                style="width: 20%"
                v-show="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
              >
                Đơn giá
              </th>

              <th
                scope="col"
                class="title-center"
                style="width: 15%"
                v-show="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
              >
                Thành tiền
              </th>
              <th
                scope="col"
                class="title-center"
                style="width: 10%"
                v-show="!approveBy"
              ></th>
            </tr>
          </thead>
          <tr v-if="listProductStock.length > 0">
            <td
              :colspan="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW') ? 3 : 3"
              class="tdTextAlignPrice"
            >
              Tổng
            </td>
            <td class="tdTextAlignPrice">{{ totalQuantity }}</td>
            <td
              class="tdTextAlignPrice"
              v-show="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
            ></td>
            <td
              class="tdTextAlignPrice"
              v-show="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
            >
              {{ formatMoney(totalPrice) }}
            </td>
            <td v-if="!approveBy"></td>
          </tr>
          <tbody v-for="(item, index) in listProductStock" :key="item.id">
            <TransferStock
              v-bind:productItem="item"
              v-bind:status="status"
              v-on:save="save"
              v-on:deleteItem="deleteItemInArray"
              v-on:update="updateItem"
              v-bind:editState="isEdit && !approveBy"
              v-on:productStockModal="openProductStockModal"
              v-bind:canViewOriginalPrice="
                checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')
              "
              v-bind:index="index"
            />
          </tbody>
          <tr>
            <td
              :colspan="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW') ? 3 : 3"
              class="tdTextAlignPrice"
            >
              Tổng
            </td>
            <td class="tdTextAlignPrice">{{ totalQuantity }}</td>
            <td
              class="tdTextAlignPrice"
              v-show="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
            ></td>
            <td
              class="tdTextAlignPrice"
              v-show="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
            >
              {{ formatMoney(totalPrice) }}
            </td>
            <td v-if="!approveBy"></td>
          </tr>
        </table>
      </template>
      <template v-slot:foot>
        <b-button
          style="font-weight: 600; width: 70px"
          variant="primary"
          size="sm"
          @click="onSubmit()"
          v-if="isEdit || !approveBy"
          >Lưu</b-button
        >
        <!-- <b-button
          :style="
            isEdit
              ? 'margin-left: 10px; font-weight: 600; width: 100px'
              : 'font-weight: 600; width: 100px'
          "
          variant="primary"
          size="sm"
          @click="exportExcel"
          >Xuất excel</b-button
        > -->
        <router-link to="/transfer-stocks" tag="button">
          <b-button
            style="margin-left: 10px; font-weight: 600; width: 70px"
            variant="secondary"
            size="sm"
            >Hủy</b-button
          >
        </router-link>
      </template>
    </KTCodePreview>
  </div>
</template>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-1.scss';
.update-transfer-stock {
  .title-center {
    text-align: center;
  }

  .autosuggest__results ul {
    list-style: none;
    cursor: pointer;
    margin-bottom: 0;
  }

  .autosuggest__results {
    position: absolute;
    background-color: #fff;
    z-index: 1;
    width: 100%;
    border: 1px solid #e0e0e0;
  }

  .autosuggest__results-container {
    position: relative;
    width: 100%;
  }

  .autosuggest__input {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    height: calc(1.35em + 1.1rem + 2px);
    padding: 0.55rem 0.75rem;
    font-size: 0.925rem;
    line-height: 1.35;
    border-radius: 0.28rem;
  }

  .autosuggest__input:focus {
    outline: none !important;
    border: 1px solid #92c5f9;
  }

  .autosuggest__results-item:hover {
    background-color: #ddd;
  }

  .autosuggest__results ul li {
    padding: 8px;
  }

  .tdTextAlignPrice {
    text-align: right !important;
    vertical-align: middle;
    font-weight: 600;
  }

  .productCode:hover {
    text-decoration: underline;
  }
}
</style>
<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import moment from 'moment';
import ApiService from '@/core/services/api.service';
import TransferStock from '@/view/components/TransferStock';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { unMaskPrice, currencyMask } from '@/utils/common';
import axios from 'axios';
import decounce from 'debounce';
import { BASE_URL, TIME_TRIGGER } from '@/utils/constants';
import localData from '@/utils/saveDataToLocal';
// import TransferIntermediate from '@/view/components/transfer-stockslips/TransferIntermediate';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import productStockInfoMixin from '@/view/pages/stocks/mixins/product-stock-info.mixin';
import productAutosuggestMixin from '@/view/pages/stocks/mixins/product-autosuggest.mixin';
import ProductStockInfoModal from '@/view/components/product-stock/ProductStockInfoModal.vue';
export default {
  mixins: [validationMixin, productAutosuggestMixin, productStockInfoMixin],

  data() {
    return {
      mask: currencyMask,

      selectedProductStock: {},
      shippingCompany: null,
      shippingInvoiceNumber: null,
      shippingCode: null,
      shippingCost: null,
      errors: [],
      codeStockBill: '',
      dateCreate: '',
      listInventories: [],
      totalPrice: 0,
      listProduct: [],
      listProductSearch: [],
      count: 0,
      description: '',
      idStock: '',
      form: {
        sourceStoreSelected: null,
        desStoreSelected: null,
        dateImport: '',
      },
      isNew: true,
      createBy: '',
      status: 0,
      approveBy: null,
      confirmBy: null,
      filteredOptionsProduct: [],
      optionsProduct: [
        {
          data: [],
        },
      ],
      searchProduct: '',
      listTypeSearch: [
        {
          id: 1,
          name: 'Tìm sản phẩm',
        },
        // {
        //   id: 2,
        //   name: 'Tìm theo IMEI',
        // },
        {
          id: 3,
          name: 'Tìm sản phẩm theo số khung',
          placeholder: 'Tìm kiếm theo số khung',
        },
        {
          id: 4,
          name: 'Tìm sản phẩm theo mã seri',
          placeholder: 'Tìm kiếm theo mã seri',
        },
      ],
      selectTypeSearch: 1,
      listProductStock: [],
      selectedClassProduct: null,
      totalQuantity: 0,
      requireStockCode: '',
      isSearching: false,
      inputSearchProductProp: {
        class: 'autosuggest__input',
        placeholder: 'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
        style: 'border-radius:0px!important',
        disabled: true,
      },
      isEdit: false,
      transferIntermediateItems: [],
    };
  },
  validations: {
    form: {
      sourceStoreSelected: { required },
      desStoreSelected: { required },
    },
  },
  components: {
    KTCodePreview,
    TransferStock,
    ProductStockInfoModal,
    // TransferIntermediate,
  },
  created() {
    this.fetchStore();
    this.getStockById();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phiếu chuyển kho', route: '/transfer-stocks' },
      { title: 'Cập nhật phiếu chuyển kho' },
    ]);
  },
  methods: {
    validateState(name) {
      if (!this.isNew) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      }
    },
    formatMoney(number) {
      return new Intl.NumberFormat('vn-VN').format(number);
    },
    save(item) {
      this.listProduct[0] = item;
      this.totalPrice = 0;
      this.checkTotalMoney();
    },
    // onSelectedProduct(option) {
    //   this.selectedClassProduct = option.item;
    //   let imeiCode = '';
    //   let quantity = 0;
    //   if (this.selectTypeSearch === 2) {
    //     imeiCode = option.item.imeiCode;
    //     quantity = 1;
    //     if (!this.isExistImeiCode(imeiCode, this.listProductStock)) {
    //       this.count++;
    //       let pro = {
    //         id: this.count,
    //         name: this.selectedClassProduct.productName,
    //         productCode: this.selectedClassProduct.productCode,
    //         barCode: this.selectedClassProduct.barCode,
    //         totalQuantityInStock:
    //           this.selectedClassProduct.totalQuantityInStock != null
    //             ? this.selectedClassProduct.totalQuantityInStock
    //             : 0,
    //         IMEI: imeiCode,
    //         proId: this.selectedClassProduct.id,
    //         price: this.selectedClassProduct.originalPrice,
    //         quantity: quantity,
    //         totalPrice: this.selectedClassProduct.originalPrice * quantity,
    //         productType: this.selectedClassProduct.productType,
    //       };
    //       this.listProductStock.unshift(pro);
    //       this.checkTotalMoney();
    //     } else {
    //       makeToastFaile('Mã IMEI đã được thêm vào danh sách!');
    //     }
    //   } else {
    //     if (this.selectedClassProduct.productType === 1) {
    //       quantity = 1;
    //       let index = this.listProductStock.findIndex(
    //         (item) => item.proId === this.selectedClassProduct.id,
    //       );
    //       if (index === -1) {
    //         let pro = {
    //           id: this.count,
    //           name: this.selectedClassProduct.productName,
    //           productCode: this.selectedClassProduct.productCode,
    //           barCode: this.selectedClassProduct.barCode,
    //           totalQuantityInStock:
    //             this.selectedClassProduct.totalQuantityInStock != null
    //               ? this.selectedClassProduct.totalQuantityInStock
    //               : 0,
    //           IMEI: imeiCode,
    //           proId: this.selectedClassProduct.id,
    //           price: this.selectedClassProduct.originalPrice,
    //           quantity: quantity,
    //           totalPrice: this.selectedClassProduct.originalPrice * quantity,
    //           productType: this.selectedClassProduct.productType,
    //         };
    //         this.listProductStock.unshift(pro);
    //       } else {
    //         this.listProductStock[index].quantity =
    //           this.listProductStock[index].quantity + quantity;
    //       }
    //       this.checkTotalMoney();
    //     } else if (this.selectedClassProduct.productType === 2) {
    //       let pro = {
    //         id: this.count,
    //         name: this.selectedClassProduct.productName,
    //         productCode: this.selectedClassProduct.productCode,
    //         barCode: this.selectedClassProduct.barCode,
    //         totalQuantityInStock:
    //           this.selectedClassProduct.totalQuantityInStock != null
    //             ? this.selectedClassProduct.totalQuantityInStock
    //             : 0,
    //         IMEI: imeiCode,
    //         proId: this.selectedClassProduct.id,
    //         price: this.selectedClassProduct.originalPrice,
    //         quantity: quantity,
    //         totalPrice: this.selectedClassProduct.originalPrice * quantity,
    //         productType: this.selectedClassProduct.productType,
    //       };
    //       this.listProductStock.unshift(pro);
    //     }
    //   }
    //   this.searchProduct = '';
    //   this.checkTotalMoney();
    // },
    onInputChangProduct(text) {
      if (!text) {
        text = '';
      }
      this.searchProduct = text;
      this.debounceInputProduct();
    },
    fetchProduct(textSearch) {
      this.isSearching = true;
      this.listProduct = [];
      this.listProductSearch = [];
      ApiService.get(
        // `stocks/get-product-by-store?storeId=${this.$v.form.sourceStoreSelected.$model}&searchProduct=${textSearch}`,
        `products/search?productName=${textSearch}&storeId=${this.$v.form.sourceStoreSelected.$model}`,
      ).then(({ data }) => {
        this.optionsProduct[0].data = [];
        const products = data.data;
        this.listProduct = products;
        products.map((element) => {
          this.optionsProduct[0].data.push(element);
        });
        this.filteredOptionsProduct = [
          {
            data: this.optionsProduct[0].data,
          },
        ];
        this.isSearching = false;
        if (textSearch !== this.searchProduct) {
          const nextSearch = this.searchProduct;
          this.fetchProduct(nextSearch);
        }
      });
    },

    fetchProductChassis(textSearch) {
      this.isSearching = true;
      this.listProduct = [];
      this.listProductSearch = [];
      if (!this.form.sourceStoreSelected) {
        makeToastFaile('Vui lòng chọn kho nguồn !!');
        return;
      }
      ApiService.get(
        `products/search/chassis-number?chassisNumber=${textSearch}&storeId=${this.form.sourceStoreSelected}`,
      )
        .then(({ data }) => {
          this.optionsProduct[0].data = [];
          const products = data.data.map((item) => {
            return {
              ...item,
              productChassis:
                item.productChassis && item.productChassis?.length
                  ? item.productChassis[0]
                  : null,
            };
          });

          this.listProduct = products;
          products.map((element) => {
            this.optionsProduct[0].data.push(element);
          });

          this.filteredOptionsProduct = [
            {
              data: this.optionsProduct[0].data,
            },
          ];
          this.isSearching = false;
          if (textSearch !== this.searchProduct) {
            const nextSearch = this.searchProduct;
            this.fetchProductChassis(nextSearch);
          }
        })
        .catch(() => (this.isSearching = false));
    },
    fetchProductSeries(textSearch) {
      this.isSearching = true;
      this.listProduct = [];
      this.listProductSearch = [];
      if (!this.form.sourceStoreSelected) {
        makeToastFaile('Vui lòng chọn kho nguồn !!');
        return;
      }
      ApiService.get(
        `products/search/serial-number?serialNumber=${textSearch}&storeId=${this.form.sourceStoreSelected}`,
      )
        .then(({ data }) => {
          this.optionsProduct[0].data = [];
          const products = data.data.map((item) => {
            return {
              ...item,
              productSeries:
                item.productSeries && item.productSeries?.length
                  ? item.productSeries[0]
                  : null,
            };
          });

          this.listProduct = products;
          products.map((element) => {
            this.optionsProduct[0].data.push(element);
          });

          this.filteredOptionsProduct = [
            {
              data: this.optionsProduct[0].data,
            },
          ];
          this.isSearching = false;
          if (textSearch !== this.searchProduct) {
            const nextSearch = this.searchProduct;
            this.fetchProductSeries(nextSearch);
          }
        })
        .catch(() => (this.isSearching = false));
    },

    onSubmit: async function () {
      this.isNew = false;
      const errors = [];
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      if (!this.shippingCost || unMaskPrice(this.shippingCode) < 0) {
        errors.push('Chi phí vận chuyển phải là số và lớn hơn hoặc bằng 0 !!');
      }

      if (!this.shippingCompany) {
        errors.push('Thiếu tên đơn vị vận chuyển');
      }

      if (this.listProductStock.length == 0) {
        errors.push('Đang không có sản phẩm nào để nhập kho');
      }
      if (errors.length) {
        errors.forEach((element) => {
          makeToastFaile(element);
        });
        return;
      }

      const listPro = this.listProductStock.map((element) => {
        const data = {
          productId: element['proId'],
          quantity: element['quantity'],
          unitPrice: unMaskPrice(element['price']),

          chassisNumber: element['chassisNumber'] || null,
          engineNumber: element['engineNumber'] || null,
          serialNumber: element['serialNumber'] || null,
        };
        if (element['id']) {
          data['id'] = element['id'];
        }
        if (element['stockSlipTransferId']) {
          data['stockSlipTransferId'] = element['stockSlipTransferId'];
        }
        return data;
      });

      const data = {
        id: this.idStock,
        sourceWarehouseId: this.$v.form.sourceStoreSelected.$model,
        destinationWarehouseId: this.$v.form.desStoreSelected.$model,
        description: this.description,
        // transferDate: this.dateImport
        //   ? moment(this.dateImport, 'DD/MM/YYYY').format('yyyy-MM-DD')
        //   : '',
        shippingCompany: this.shippingCompany,
        shippingInvoiceNumber: this.shippingInvoiceNumber,
        shippingCode: this.shippingCode,
        shippingCost: unMaskPrice(this.shippingCost || 0),
        stockSlipTransferDetails: listPro,
      };
      ApiService.put(`stockslip-transfer`, data)
        .then(({ data }) => {
          if (data.status === 1) {
            this.listProduct = [];
            makeToastSuccess(data.message);
            this.$router.push({
              path: '/transfer-stocks',
            });
          } else {
            makeToastFaile(data.message);
          }
        })
        .catch(({ response }) => {
          if (response.data.errorCode === 'PRODUCT_STOCK_NOT_ENOUGH') {
            const uuidRegex =
              /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;
            const match = response.data.message.match(uuidRegex);
            if (match) {
              const uuid = match[0];

              const product = this.listProductStock.find(
                (item) => item.productId === uuid,
              );
              makeToastFaile(
                Object.keys(product).length > 0
                  ? `Sản phẩm ${product.name} không đủ tồn để xuất kho`
                  : 'Có vấn đề xảy ra hãy thử lại',
              );
              return;
            }
          }
          makeToastFaile(
            response.data?.message || 'Có vấn đề xảy ra hãy thử lại',
          );

          setTimeout(() => {
            this.isNew = true;
          }, TIME_TRIGGER);
        });
    },
    checkTotalMoney() {
      this.totalPrice = 0;
      this.totalQuantity = 0;
      this.listProductStock.forEach((element) => {
        let total = element.quantity * unMaskPrice(element.price);
        this.totalPrice += total;
        this.totalQuantity += parseInt(element.quantity);
      });
    },
    fetchStore() {
      ApiService.get(`stores?limit=10000&page=1`).then(({ data }) => {
        this.listInventories = data.data.data;
      });
    },
    deleteItemInArray(id) {
      for (var i = 0; i < this.listProductStock.length; i++) {
        if (this.listProductStock[i].id === id) {
          this.listProductStock.splice(i, 1);
        }
      }
      this.totalPrice = 0;
      this.checkTotalMoney();
    },
    updateItem(item) {
      this.listProductStock.forEach((element, index) => {
        if (element.id === item.id) {
          this.listProductStock[index].name = item.name;
          this.listProductStock[index].IMEI = item.IMEI;
          this.listProductStock[index].proId = item.proId;
          this.listProductStock[index].price = item.price;
          this.listProductStock[index].quantity = parseInt(item.quantity);
          this.listProductStock[index].totalPrice = item.totalPrice;
        }
      });
      this.totalPrice = 0;
      this.checkTotalMoney();
    },
    onChangeTypeSearch() {
      this.optionsProduct[0].data = [];
      this.filteredOptionsProduct = [];
      this.inputSearchProductProp.placeholder = this.listTypeSearch.find(
        (item) => item.id == this.selectTypeSearch,
      )?.placeholder;
    },
    getStockById() {
      const id = this.$route.query.id;
      ApiService.get(`/stockslip-transfer/${id}/detail`).then(({ data }) => {
        let dataRes = data.data;
        this.codeStockBill = dataRes.code;
        this.dateCreate = moment(String(dataRes.createdAt)).format(
          'HH:mm DD/MM/YYYY',
        );
        // this.$v.form.dateImport.$model = moment(
        //   String(dataRes.transferDate),
        // ).format('DD-MM-YYYY');
        this.$v.form.sourceStoreSelected.$model = dataRes.sourceWarehouseId;
        this.$v.form.desStoreSelected.$model = dataRes.destinationWarehouseId;
        // this.totalPrice = dataRes.totalAmount;
        this.description = dataRes.description;
        this.createBy = dataRes.userCreated?.fullName;
        // this.status = dataRes.status;
        this.approveBy = dataRes.approveBy;
        this.confirmBy = dataRes.confirmBy;
        this.idStock = dataRes.id;
        this.requireStockCode = dataRes.stockSlip;
        this.shippingCompany = dataRes.shippingCompany;
        this.shippingInvoiceNumber = dataRes.shippingInvoiceNumber;
        this.shippingCode = dataRes.shippingCode;
        this.shippingCost = dataRes.shippingCost;

        dataRes.stockSlipTransferDetail.forEach((item) => {
          this.count++;
          let dataItem = {
            id: item.id,
            name: item.product?.name,
            productId: item.productId,
            price: item.unitPrice || 0,
            productType: item.product?.type,
            chassisNumber: item.chassisNumber,
            serialNumber: item.serialNumber,
            engineNumber: item.engineNumber,
            quantity: item.quantity,
            // quantityRequire: item.quantity,
            totalPrice: item.totalAmount,
            productCode: item.product?.code,
            totalQuantityInStock:
              item.product?.productStock[0]['inStockQuantity'] || 0,
            stockSlipTransferId: item.stockSlipTransferId,
          };
          this.listProductStock.push(dataItem);
        });
        // this.transferIntermediateItems = dataRes.transferIntermediates.map(
        //   (transferIntermediate, index) => {
        //     return {
        //       count: index + 1,
        //       ...transferIntermediate,
        //     };
        //   },
        // );
        this.inputSearchProductProp.disabled = !dataRes.approveBy
          ? false
          : true;
        this.checkTotalMoney();
      });
    },
    fetchProductImei(textSearch) {
      this.isSearching = true;
      this.listProduct = [];
      ApiService.get(
        `stocks/get-product-by-store-imei?storeId=${this.$v.form.sourceStoreSelected.$model}&searchProduct=${textSearch}`,
      ).then(({ data }) => {
        this.optionsProduct[0].data = [];
        const products = data.data;
        this.listProduct = products;
        if (products.length === 1) {
          this.selectedClassProduct = products[0];
          this.count++;
          let pro = {
            id: this.count,
            name: this.selectedClassProduct.productName,
            productCode: this.selectedClassProduct.productCode,
            barCode: this.selectedClassProduct.barCode,
            totalQuantityInStock:
              this.selectedClassProduct.totalQuantityInStock != null
                ? this.selectedClassProduct.totalQuantityInStock
                : 0,
            IMEI: this.selectedClassProduct.imeiCode,
            proId: this.selectedClassProduct.id,
            price: this.selectedClassProduct.originalPrice,
            quantity: 1,
            totalPrice: this.selectedClassProduct.originalPrice,
            productType: this.selectedClassProduct.productType,
          };
          this.listProductStock.unshift(pro);
          this.checkTotalMoney();
          this.searchProduct = '';
          this.isSearching = false;
        } else {
          products.map((element) => {
            this.optionsProduct[0].data.push(element);
          });
          this.filteredOptionsProduct = [
            {
              data: this.optionsProduct[0].data,
            },
          ];
          this.isSearching = false;
          if (textSearch !== this.searchProduct) {
            const nextSearch = this.searchProduct;
            this.fetchProductImei(nextSearch);
          }
        }
      });
    },
    exportExcel: async function () {
      let baseUrl = BASE_URL;
      let url = `${baseUrl}stocks/export-excel/${this.idStock}?type=3`;
      await axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        let headerLine = response.headers['content-disposition'];
        let startFileNameIndex = headerLine.indexOf('"') + 1;
        let endFileNameIndex = headerLine.lastIndexOf('"');
        let filename = headerLine.substring(
          startFileNameIndex,
          endFileNameIndex,
        );
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', filename);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
    linkToRequireStock: function (item) {
      this.$router.push({
        name:
          item.type === 'REQUIRE_EXPORT_STOCK'
            ? 'update-export-stock'
            : 'update-stock',
        query: { id: item.id },
      });
    },

    searchProductAPI() {
      let textSearch = this.searchProduct ? this.searchProduct.trim() : '';
      if (!this.isSearching && textSearch.length > 3) {
        if (this.selectTypeSearch === 4) {
          this.fetchProductSeries(textSearch);
        } else if (this.selectTypeSearch === 3) {
          this.fetchProductChassis(textSearch);
        } else if (this.selectTypeSearch === 2) {
          this.fetchProductImei(textSearch);
        } else {
          this.fetchProduct(textSearch);
        }
      }
    },

    debounceInputProduct: decounce(function () {
      this.searchProductAPI();
    }, TIME_TRIGGER),

    checkPermission: function (condition) {
      return localData.checkPermission(condition);
    },
  },
};
</script>
